import React from 'react';
import {Box, Button, Typography} from "@material-ui/core";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {useEffect, useState} from "react";
import AddOtherNewPayments from "../AddOtherNewPayments/AddOtherNewPayments";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {OtherPaymentService} from "./OtherPaymentService";
import {convertCurrencyFormat} from "../../utils/numberConvertor";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

let page = 0;
let selectedId = -1
const OtherPayments = () => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new OtherPaymentService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, [])

    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);

    const [otherPaymentsList, setOtherPaymentsList] = useState([]);
    const [needRefresh, setNeedRefresh] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const showEventsContent = (rowId) => {
        selectedId = rowId
        setOpenDialog(true)
    }
    const handleChange = (event, value) => {
        page = value - 1
        getDataFromServer()
    };
    // dialog-start
    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        selectedId = -1
        if (needRefresh) {
            getDataFromServer()
        }
    };

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getOtherPaymentList(page)
            .then(response => {
                setOtherPaymentData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت لیست سایر پرداختی ها", snackbar, loading)
        })
    }

    function setOtherPaymentData(data) {
        setItemCount(data.numberOfItems)
        setPageCount(data.totalPage)
        setOtherPaymentsList([])

        data.data.map((item, index) => {
            setOtherPaymentsList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 10) + index + 1,
                    item.title,
                    convertCurrencyFormat(item.amountPerUnit),
                    item.enabled
                )
            ])
        })
    }

    function prepareGroupsJsonList(id, number, title, amountPerUnit, enabled) {
        return {
            id: id,
            number: number,
            title: title,
            paid: amountPerUnit,
            state: enabled ? <span className="bg_active_state">فعال</span> :
                <span className="bg_deActive_state">غیر فعال</span>,
        }
    }

    // dialog-end
    return (
        <>
            {
                <AddOtherNewPayments
                    openDialog={openDialog}
                    handleClickOpen={handleClickOpen}
                    handleClose={handleClose}
                    selectedItem={selectedId}
                    needRefresh={setNeedRefresh}
                />
            }
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            لیست سایر پرداخت ها
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " پرداخت ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={() => {
                            // selectedItemId = -1
                            setOpenDialog(true)
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن
                    </Button>
                </Box>


                <CustomTable
                    header={columns}
                    data={otherPaymentsList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>

    )
}
export default OtherPayments


const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'title', label: 'عنوان', align: 'right'},
    {id: 'paid', label: 'مبلغ واحد (ریال)', align: 'right'},
    {id: 'state', label: 'وضعیت', align: 'right'},
];
